  import Cost from "components/Pdf/CostReport";
  import React, { Fragment, useContext, useEffect, useState } from "react";
  import {
    useHistory,
    useParams,
  } from "react-router-dom/cjs/react-router-dom.min";
  import AuthContext from "store/auth-context";
  import AxiosContext from "store/axios-context";
  import { useLocation } from "react-router-dom";
  
  export default function GeneratePdf() {
    const params = useParams();
    const history = useHistory();
    const axiosCtx = useContext(AxiosContext);
    const authCtx = useContext(AuthContext);
    const location = useLocation();
    const [data, setData] = useState(null);
    const [currency, setCurrency] = useState(null);
  
    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
    const costId = queryParams.get("cost_id");
    const jobId = queryParams.get("job_id");
    const selectedCurrency = queryParams.get("currency") || "£";
      if (authCtx.isLoggedIn == false) {
        history.replace("/auth/Login");
      }
    
      if (costId && jobId) {
       // Debugging purpose
        axiosCtx.instance
          .get(`show-cost?cost_id=${costId}&job_id=${jobId}`)
          .then((response) => {
            console.log(response.data.data);
            setData(response.data.data);
            setCurrency(selectedCurrency);
          })
          .catch((error) => {
            alert("Something went wrong!");
          });
      }
    }, [location.search, axiosCtx.instance]);
  
    return <Fragment>{data && <Cost data={data} currency={currency} />}</Fragment>;
  }
  